export const ClickToEditTextareaDirective = ['ClickToEditFactory', function(ClickToEditFactory) {
   return ClickToEditFactory.get('textarea', true);
}];
